module.exports = {

    // 战斗类型返回，有一些窗体，需要等这个事件之后，才判断是否显示面板
    COMBAT_TYPE_BACK : "COMBAT_TYPE_BACK",
    MOVE_DRAMA_EVENT : "MOVE_DRAMA_EVENT",
    //关闭结算界面
    CLOSE_RESULT_VIEW: "CLOSE_RESULT_VIEW",
    // 回合数更新
    UPDATE_ROUND_NUM : "UPDATE_ROUND_NUM",
    //退出战斗
    EXIT_FIGHT : "SceneEvent.EXIT_FIGHT",

}